import type {
  WheelChangeTimingPreferenceListApiData,
  WheelChangeTimingPreferenceListApiResponses,
  WheelChangeTimingPreferencePatchApiData,
  WheelChangeTimingPreferencePatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getWheelChangeTimingUrls = {
  getCarWheelChangeTimingPreferences: dataEndpoint<
    WheelChangeTimingPreferenceListApiData,
    WheelChangeTimingPreferenceListApiResponses
  >({
    getUrl: ({ carId, ...queryParams }) => apiUrl(`cars/${carId}/wheel-change-timing-preferences/`, queryParams)
  }),
  patchCarWheelChangeTimingPreference: responseEndpoint<
    WheelChangeTimingPreferencePatchApiData,
    WheelChangeTimingPreferencePatchApiResponses
  >({
    getUrl: ({ carId }) => apiUrl(`cars/${carId}/wheel-change-timing-preferences/`),
    getBody: ({ carId: _, ...body }) => body
  })
};
